import { render, staticRenderFns } from "./TaskListComponent.vue?vue&type=template&id=35600da0&scoped=true&"
import script from "./TaskListComponent.vue?vue&type=script&lang=js&"
export * from "./TaskListComponent.vue?vue&type=script&lang=js&"
import style0 from "./TaskListComponent.vue?vue&type=style&index=0&id=35600da0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35600da0",
  null
  
)

export default component.exports